<template>
  <div>
    <div class="mywish" v-for="(item, index) in list" :key="index">
      <!-- 信息展示 -->
      <div class="review_top">
        <div class="review_left" @click="jumpDetail(item.wish.id)">
          <img :src="item.user.avatar" />
        </div>
        <div class="review_right">
          <div class="review_right_top">
            <div class="review_name" @click="jumpDetail(item.wish.id)">
              {{ item.user.nick }}
            </div>
            <div
              v-if="
                item.user.type === 2 && state == 0 && item.claim_state === 1
              "
              class="review_btn"
              style="margin-right:4px"
              @click="giveUpWish(item.wish.id)"
            >
              放弃认领
            </div>
            <!-- 按钮区域 已认领心愿 state 为  0 -->
            <div class="review_btn" v-if="item.claim_state === 0 && state == 0">
              待审核
            </div>
            <div class="review_btn" v-if="item.claim_state === 1 && state == 0">
              认领成功
            </div>
            <div class="review_btn" v-if="item.claim_state === 2 && state == 0">
              已完成
            </div>
            <div
              class="review_btn"
              v-if="item.claim_state === -2 && state == 0"
            >
              已放弃
            </div>
            <div
              class="review_btn"
              v-if="item.claim_state === -1 && state == 0"
            >
              审核失败
            </div>
            <!-- 按钮区域 已认领心愿 state 为 0 end -->

            <!-- 按钮区域 我的心愿 state 为 1 start-->
            <div class="review_btn" v-if="item.wish.state === 0 && state == 1">
              待审核
            </div>
            <div class="review_btn" v-if="item.wish.state === 1 && state == 1">
              待认领
            </div>
            <div class="review_btn" v-if="item.wish.state === 2 && state == 1">
              进行中
            </div>
            <div class="review_btn" v-if="item.wish.state === 3 && state == 1">
              已完成
            </div>
            <div class="review_btn" v-if="item.wish.state === 4 && state == 1">
              已评价
            </div>
            <div class="review_btn" v-if="item.wish.state === -1 && state == 1">
              审核失败
            </div>
            <div
              class="review_btn"
              style="margin-left:5px"
              v-if="item.wish.state === -1 && state == 1"
              @click="handleDelete(item.wish.id)"
            >
              删除
            </div>
            <!-- 按钮区域 我的心愿 state 为 1 end-->
          </div>
          <div class="review_right_bottom">
            <div class="review_address">
              {{ item.wish.city }}·{{ item.wish.area }}
            </div>
            <div class="review_time">{{ item.wish.add_time }}</div>
          </div>
        </div>
      </div>
      <div class="review_main" @click="jumpDetail(item.wish.id)">
        {{ item.wish.content }}
      </div>
      <div class="review_bottom" v-if="item.imglist.length>0"  @click="jumpDetail(item.wish.id)">
        <div class="review_box" v-for="i in item.imglist" :key="i.id">
          <img v-if="i.type === 1" :src="i.file_url" />
          <video v-if="i.type === 2" :src="i.file_url"></video>
        </div>
      </div>
      <!-- 心愿详情进度 -->
      <div
        class="progressTitle"
        @click="jumpDetail(item.wish.id)"
        v-if="item.process_list.length > 0"
      >
        · 心愿详情进度 ·
      </div>
      <div
        class="progress_box"
        @click="jumpDetail(item.wish.id)"
        v-if="item.process_list.length > 0"
      >
        <!-- 我的心愿 -->
        <Toggle v-if="state == 1" :list="item.claim_userlist">
          <Progress slot="content" :list="item.process_list" />
        </Toggle>
        <!-- 已认领心愿 -->
        <Progress :list="item.process_list" v-if="state == 0" />
      </div>
      <!-- 按钮区域 已认领心愿 state 为 0 按钮状态：更新进度，已完成， 党员多了一个审核中按钮-->
      <div class="btn_section" v-if="state == 0">
        <Button
          :button="button"
          v-if="item.wish.state === 2"
          @click.native="updateProgress(item.wish.id)"
        />
        <div class="progress_btn" v-if="item.wish.state >= 3">已完成</div>
        <div
          class="progress_btn"
          v-if="item.wish.state === 0 && userInfo.type == 2"
        >
          审核中
        </div>
      </div>
      <!-- 失败原因 仅在我的心愿中展示-->
      <div class="error_msg" v-if="item.wish.state === -1 && state == 1">
        审核失败原因： {{ item.wish.error_msg }}
      </div>
    </div>
  </div>
</template>

<script>
import Toggle from "@/components/Toggle";
import Progress from "@/components/Progress";
import Button from "@/components/Button";
export default {
  // userInfo (type  1普通用户2党员3机构管理员)
  // state 0 已认领心愿 1 我的心愿
  // list 我的心愿 已认领心愿 数据
  props: ["list", "state", "userInfo"],
  components: {
    Toggle,
    Progress,
    Button,
  },
  data() {
    return {
      button: "更新进度",
      progressList: [], //进度数据
    };
  },
  created() {},
  methods: {
    // 放弃认领
    giveUpWish(id) {
      this.$dialog
        .confirm({
          title: "提醒",
          message: "确认放弃认领当前心愿吗",
        })
        .then(() => {
          let data = {
            wishid: id,
          };
          this.$api.giveupClaimWish(data);
          this.$toast("操作成功");
        });
    },
    // 删除当前心愿
    handleDelete(id) {
      let data = {
        wishid: id,
      };
      this.$dialog
        .confirm({
          title: "提醒",
          message: "确定删除当前心愿吗",
        })
        .then(() => {
          this.$api.deleteWish(data);
        });
    },
    // 更新进度
    updateProgress(id) {
      this.$router.push({
        path: "./update",
        query: { id: id },
      });
    },
    // 跳转详情
    jumpDetail(id) {
      this.$router.push({
        path: "/wishDetail",
        query: { id: id },
      });
    },
  },
};
</script>
<style lang="scss">
.mywish {
  .btn {
    width: 130px;
    height: 30px;
    span {
      font-size: 15px;
    }
  }
  .progress_box {
    border: 0 !important;
    .progress {
      margin-top: 15px;
      margin-bottom: 10px;
    }
    .progress .more {
      padding-bottom: 0;
    }
  }
  .progress .progress_content .progress_content_item .progress_infos {
    background-color: #ffe5e5;
  }
  .progress .progress_content .progress_content_item .progress_infos::before {
    border-right: 0.34667rem solid #ffe5e5;
  }
  .progress .progress_content .progress_line {
    height: 80%;
  }
}
</style>

<style lang="scss" scoped>
.btn_section {
  display: flex;
  align-items: center;
  justify-content: center;
  .progress_btn {
    width: 130px;
    height: 30px;
    background-color: #dcdcdc;
    border-radius: 30px;
    font-size: 15px;
    line-height: 30px;
    color: #999999;
    margin-top: 10px;
    margin-bottom: 10px;
  }
}
/* 信息展示 */
.mywish {
  position: relative;
  width: 335px;
  background-color: #ffffff;
  box-shadow: 1px 2px 6px 0px rgba(230, 0, 18, 0.1);
  border-radius: 8px;
  z-index: 1;
  margin: 0 auto 10px;
  padding-bottom: 10px;
  /* 心愿详情进度 */
  .progressTitle {
    font-size: 17px;
    line-height: 20.5px;
    color: #e60012;
    font-weight: 800;
    text-align: center;
    padding: 15px 0 0;
    margin: 10px 15px 0;
    box-sizing: border-box;
    border-top: 1px dashed rgba(229, 0, 18, 0.3);
  }
  .progress_box {
    width: 335px;
    border-radius: 10px;
    margin: 0 auto 0;
    border: solid 2px rgba($color: #ca0908, $alpha: 0.5);
    border-top: 0;
    border-radius: 10px;
  }
  .review_top {
    display: flex;
    padding: 9.5px 15px 0 10px;
    align-items: center;
    .review_left {
      width: 33px;
      height: 33px;
      margin-right: 9px;
      // overflow: hidden;
      img {
        width: 33px;
        height: 33px;
        border-radius: 50%;
        object-fit: cover;
      }
    }
    .review_right {
      flex: 1;
      display: flex;
      flex-direction: column;
    }
    .review_right_top {
      flex: 1;
      display: flex;
      align-content: center;
      // justify-content: space-between;
      .review_name {
        flex: 1;
        text-align: left;
        font-size: 14px;
        line-height: 1;
        color: #666666;
        margin-top: 2px;
        margin-bottom: 4px;
      }
      .review_btn {
        display: flex;
        align-items: center;
        width: 56px;
        height: 15px;
        border-radius: 10px;
        border: solid 1px #d2d2d2;
        font-size: 12px;
        color: #999999;
        justify-content: center;
      }
    }
    .review_right_bottom {
      flex: 1;
      display: flex;
      align-content: center;
      justify-content: space-between;
      margin-top: 5px;
      .review_address {
        font-size: 10px;
        line-height: 1;
        color: rgba(102, 102, 102, 0.7);
      }
      .review_time {
        line-height: 1;
        font-size: 10px;
        color: rgba(102, 102, 102, 0.7);
      }
    }
  }
  .review_main {
    width: 284px;
    font-size: 12px;
    line-height: 1.4;
    letter-spacing: 0.5px;
    color: #666666;
    padding: 0 11px;
    width: 100%;
    box-sizing: border-box;
    text-align: left;
    margin-top: 13px;
  }
  .review_bottom {
    padding: 0 11px;
    width: 100%;
    display: flex;
    margin-top: 9.5px;
    box-sizing: border-box;
    img {
      width: 100px;
      height: 61px;
      border-radius: 3px;
      margin-right: 10px;
      object-fit: cover;
    }
    img:nth-child(3n) {
      margin-right: 0;
    }
  }
  .error_msg {
    padding: 0 11px;
    width: 100%;
    font-size: 12px;
    line-height: 1.4;
    letter-spacing: 0.5px;
    color: #666666;
    padding: 0 11px 10px;
    width: 100%;
    box-sizing: border-box;
    text-align: left;
    margin-top: 10px;
    margin-bottom: 10px;
  }
}
</style>
